import * as React from 'react';

import {setBodyId} from '../../../dom';
import {PageContainer, PageTitleBar} from '../../../ui/layout';
import {QuoteManagePage} from '../../../ui/setup/sales-documents/quotes/quote-manage-page';

export function QuoteManagePageStandalone() {
    setBodyId('quote-manage');

    return (
        <PageContainer
            noPadding={true}
            title='Quotes'
            pageTitleBar={
                <PageTitleBar
                    title='Quotes'
                    subheaderPrimaryText='View, download, and restore quotes'
                />
            }
        >
            <QuoteManagePage />
        </PageContainer>
    );
}
